import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class PaymentService {
    async getPayment(): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.PAYMENT}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async editPayment(data: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.PAYMENT}/${data.uuid}`, data);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao editar" }; // Retorna um objeto de erro
        }
    }
}


const paymentService = new PaymentService();
export default paymentService;